import { render, staticRenderFns } from "./RepeatSummary.vue?vue&type=template&id=2fb8420e"
import script from "./RepeatSummary.vue?vue&type=script&lang=js"
export * from "./RepeatSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports